'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosPaperOutline = function IoIosPaperOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm8.8 5h26.2v27.6c0 1.3-1.1 2.4-2.4 2.4h-25.2c-1.3 0-2.4-1.1-2.4-2.4v-23.8h2.5v1.2h-1.2v22.6c0 0.6 0.5 1.2 1.1 1.2h25.2c0.6 0 1.1-0.6 1.1-1.2v-26.3h-23.7v25h-1.2v-26.3z m3.7 5v-1.2h10v1.2h-10z m0 6.3v-1.3h18.8v1.3h-18.8z m0 6.2v-1.2h15v1.2h-15z m0 6.3v-1.3h18.8v1.3h-18.8z' })
        )
    );
};

exports.default = IoIosPaperOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-paper-outline.js
// module id = 2460
// module chunks = 0